import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

// use video orverlay + custom style for CTA
import VideoOverlay from '../../../Core/VideoOverlay';

import { TitleWrapper, Wrapper, LinkWrapper } from './styles';

const VideoPlayerWithCTA = ({ data }) => {
  if (!data) return null;
  const {
    titleHtml,
    subtitleHtml,
    image,
    imageSharp,
    bannerCTA,
    ctaType,
    ariaLabel,
    queryString,
    bannerCTAText,
  } = data;
  return (
    <Wrapper id="video-player-cta">
      <VideoOverlay
        thumbnail={imageSharp ? imageSharp.publicURL : image.url}
        className="video-with-cta-overlay"
      >
        <TitleWrapper>
          {ReactHtmlParser(titleHtml)}
          {ReactHtmlParser(subtitleHtml)}

          {/* CTA with link wrapper containing proper margins */}
          <LinkWrapper
            className={`${ctaType} auto-size`}
            to={bannerCTA.url}
            ariaLabel={ariaLabel}
            queryString={queryString}
          >
            {bannerCTAText}
          </LinkWrapper>
        </TitleWrapper>
      </VideoOverlay>
    </Wrapper>
  );
};

VideoPlayerWithCTA.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default VideoPlayerWithCTA;
